// extracted by mini-css-extract-plugin
export default {"description":"style_description__ZYm4N","fade-in":"style_fade-in__ZqSvv","top":"style_top__5jjtj","image":"style_image__nEXc4"};